import React, { useState } from 'react';

/**
 * Collapsible "Como funciona?" info panel.
 *
 * props:
 * - title    string         — section title (default: 'Como funciona?')
 * - children React nodes   — content to show inside
 */
function HowItWorks({ title = 'Como funciona?', children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className='mb-3'>
            <button
                type='button'
                className='btn btn-sm btn-outline-secondary d-flex align-items-center gap-1'
                onClick={() => setOpen(o => !o)}
                aria-expanded={open}
            >
                <svg className='icon icon-xs' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path fillRule='evenodd' d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z' clipRule='evenodd' />
                </svg>
                {title}
                <svg className={`icon icon-xs ms-1 transition ${open ? 'rotate-90' : ''}`} fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path fillRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clipRule='evenodd' />
                </svg>
            </button>
            {open && (
                <div className='card card-body border-0 shadow-sm mt-2 text-muted small'>
                    {children}
                </div>
            )}
        </div>
    );
}

export default HowItWorks;
